<template>
  <div class="bookings">
    <div class="py-5 bg-white w-100 flex items-center justify-center mt-5" style="height: 60vh" v-if="loading">
      <loader />
    </div>

    <div class="table-wrapper" id="table-wrapper">
      <table class="custom-table">
        <thead>
          <tr>
            <th class="width-xs">
              <base-checkbox v-model="shouldSelectAllBookings" />
            </th>
            <th v-for="header in activeHeaders" :key="header">{{ header.name }}</th>

            <th class="width-xs">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                @click="showFilterModal = true" class="cursor-pointer">
                <g opacity="0.7">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                    fill="#383F51" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                    fill="#383F51" />
                </g>
              </svg>
            </th>
          </tr>
        </thead>

        <tbody v-if="bookings.length">
          <tr v-for="booking in bookings" :key="booking.id">
            <td>
              <base-checkbox :value="booking.id" @change="$emit('newSelect', selectedBookings)"
                v-model="selectedBookings" />
            </td>

            <td v-for="header in activeHeaders" :key="header">
              <!-- Special case for Sender (merge name and phone) -->
              <span v-if="header.name === 'SENDER'">
                {{ booking.sender && booking.sender.contactName
                  ? booking.sender.contactName : 'N/A' }}<br />
                {{ booking.sender && booking.sender.mobile ? booking.sender.mobile :
                  'N/A'
                }}
              </span>

              <!-- Special case for Status -->
              <span v-else-if="header.name === 'ORDER STATUS'">
                <button :title="booking.orderStatus.replace(/_/g, ' ')" :class="['order_status']"
                  :style="{ ...statusColors(booking.orderStatus) }">{{ booking.orderStatus.replace(/_/g, ' ').toLowerCase()}}</button>
              </span>

              <!-- Special case for RECEIVER (merge name and phone) -->
              <span v-else-if="header.name === 'RECEIVERS'">
                {{ receieverContactName(booking) }}
              </span>
              <span v-else-if="header.name === 'SHIP TO (DESTINATION)'">
                {{ recieverAddress(booking) }}
              </span>

              <!-- Special case for RECEIVER (merge name and phone) -->
              <span v-else-if="header.name === 'SHIPPING REF. + DATE'">
                {{ booking.reference || 'N/A' }}<br />
                {{ booking.createdAt ? booking.createdAt.split("T")[0] : "N/A" }}
                <span class="block w-full opacity-50">{{ booking.createdAt ?
                  addoneHourToTime(booking.createdAt) : "" }}</span>
              </span>
              <!-- Default case for other headers -->
              <span v-else>
                {{ getNestedValue(booking, headerMap[header.name]) }}
              </span>
            </td>



            <td class="ml-3 cursor-pointer relative" tabindex="-1">
              <el-dropdown trigger="click">
                <button class="p-3">
                  <vertical-ellipsis />
                </button>
                <el-dropdown-menu  slot="dropdown">
                  <el-dropdown-item disabled>ACTIONS</el-dropdown-item>
                  <el-dropdown-item v-if="
                    booking.terminalStatus == 'scheduled' ||
                    'completed' ||
                    'active'
                  ">
                    <button class="flex items-center" v-if="booking.terminalStatus != 'draft'"
                      @click="viewDestination(booking)">
                      <details-icon />
                      <span class="ml-2">View Details</span>
                    </button>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="
                    booking.terminalStatus == 'completed' ||
                    ('active' && booking.terminalStatus != 'scheduled')
                  ">
                    <router-link :to="{
                      name: 'BookingNewTimeLine',
                      params: { id: booking.shipingId },
                    }" class="flex items-center d-flex router" v-if="booking.terminalStatus != 'draft'">
                      <details-icon />
                      <span class="ml-2 font-normal">View Timeline</span>
                    </router-link>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="
                    booking.terminalStatus == 'active' ||
                    ('active' && booking.terminalStatus != 'scheduled')
                  ">
                    <button class="flex items-center" @click="updateStatus(booking)" v-if="
                      booking.terminalStatus != 'canceled' &&
                      booking.terminalStatus != 'delivered' &&
                      booking.terminalStatus != 'declined' &&
                      booking.terminalStatus != 'draft' &&
                      booking.terminalStatus != 'process_handoff' &&
                       (currentMethod == 'terminal-to-terminal' || currentMethod == 'door-to-door' || currentMethod == 'terminal-to-door')
                    ">
                      <update-icon />
                      <span class="ml-2">Update Status</span>
                    </button>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="
                    booking.terminalStatus != 'draft' &&
                    booking.terminalStatus != 'scheduled'
                  ">
                    <button class="flex items-center" @click="
                      (selectedBooking = booking),
                      (showProcessHandoffModal = true)
                      " v-if="
                        booking.terminalStatus != 'canceled' &&
                        booking.terminalStatus != 'delivered' &&
                        booking.terminalStatus != 'declined' &&
                        booking.terminalStatus != 'process_handoff' &&
                        currentMethod == 'terminal-to-terminal'
                      ">
                      <process-icon />
                      <span class="ml-2">Process Hand-Off</span>
                    </button>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="
                    booking.terminalStatus != 'draft' &&
                    booking.terminalStatus != 'scheduled' &&
                    currentMethod
                  ">
                    <button class="flex items-center" @click="
                      (selectedBooking = booking),
                      (showProcessFulfillmentModal = true)
                      " v-if="
                        booking.terminalStatus != 'canceled' &&
                        booking.terminalStatus != 'delivered' &&
                        booking.terminalStatus != 'declined' &&
                        booking.terminalStatus != 'process_handoff' &&
                        currentMethod == 'terminal-to-terminal'
                      ">
                      <fulfillment-icon />
                      <span class="ml-2">Process Fulfillment</span>
                    </button>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="
                    booking.terminalStatus != 'draft' &&
                    booking.terminalStatus != 'scheduled'
                  ">
                    <button class="flex items-center" @click="
                      (selectedBooking = booking),
                      (showProcessReturnModal = true)
                      " v-if="
                        booking.terminalStatus != 'canceled' &&
                        booking.terminalStatus != 'delivered' &&
                        booking.terminalStatus != 'process_handoff' &&
                        booking.terminalStatus != 'declined'
                      ">
                      <accept-package-icon />
                      <span class="ml-2">Process Return</span>
                    </button>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="
                    booking.terminalStatus != 'draft' &&
                    booking.terminalStatus != 'scheduled' &&
                    booking.terminalStatus != 'process_handoff' &&
                    booking.terminalStatus != 'delivered' &&
                    booking.terminalStatus != 'canceled'
                  ">
                    <button class="flex items-center" @click="
                      (selectedBooking = booking),
                      (showUploadDocumentModal = true)
                      " v-if="
                        booking.terminalStatus != 'canceled' &&
                        booking.terminalStatus != 'delivered' &&
                        booking.terminalStatus != 'declined' &&
                        booking.terminalStatus != 'process_handoff' &&
                        booking.terminalStatus != 'delivered'
                      ">
                      <upload-doc-icon />
                      <span class="ml-2">Upload Doc</span>
                    </button>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="booking.terminalStatus != 'scheduled'">
                    <button class="flex items-center" @click="
                      (selectedBooking = booking), (showCancelModal = true)
                      " v-if="
                        booking.terminalStatus != 'canceled' &&
                        booking.terminalStatus != 'delivered' &&
                        booking.terminalStatus != 'declined' &&
                        booking.terminalStatus != 'draft' &&
                        booking.terminalStatus != 'process_handoff' &&
                        currentMethod == 'terminal-to-terminal'
                      ">
                      <cancel-icon />
                      <span class="ml-2">Cancel Pickup</span>
                    </button>
                  </el-dropdown-item>

                  <!-- <el-dropdown-item v-if="
                    booking.terminalStatus == 'scheduled' ||
                    'completed' ||
                    'active'
                  ">
                    <button class="flex items-center" v-if="booking.terminalStatus != 'draft'" @click="
                      (selectedBooking = booking),
                      viewDestination(booking)
                      ">
                      <span class="icon"><img alt="" class="mr-1"
                          src="@/assets/images/billing/icon-eye-alt.svg" /></span>
                      <span class="ml-2">View Trip</span>
                    </button>
                  </el-dropdown-item> -->

                  <el-dropdown-item v-if="booking.terminalStatus == 'draft'">
                    <button class="flex items-center" @click="action(booking.id, booking)">
                      <update-icon />
                      <span class="ml-2">Update</span>
                    </button>
                  </el-dropdown-item>

                  <!-- <el-dropdown-item v-if="
                    booking.terminalStatus != 'draft' &&
                    booking.terminalStatus != 'scheduled'
                  ">
                    <button class="flex items-center" @click="
                      (selectedBooking = booking),
                      (showReceiveShippingModal = true)
                      " v-if="
                        booking.terminalStatus != 'canceled' &&
                        booking.terminalStatus != 'delivered' &&
                        booking.terminalStatus != 'declined' &&
                        booking.terminalStatus != 'process_handoff' &&
                        currentMethod == 'terminal-to-terminal'
                      ">
                      <accept-package-icon />
                      <span class="ml-2">Receive Shipping</span>
                    </button>
                  </el-dropdown-item> -->


                  <el-dropdown-item v-if="booking.terminalStatus == 'draft'">
                    <button class="flex items-center" @click="viewDeleteModal(booking.id)">
                      <cancel-icon />
                      <span class="ml-2">Delete</span>
                    </button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr class="custom-table">
            <td colspan="18">
              <div class="flex flex-col items-center gap-2 justify-center w-100 mirror">
                <empty-booking-icon />
                <p>No Bookings Currently</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="deleteModal" v-if="showDeleteModal == true">
      <div class="text-center modals-wrapper px-5 card" style="width: 500px">
        <img src="../../../../../assets/images/icons/confirm.svg" class="mx-auto" />
        <p class="mt-4 w-11/12 text-center">
          Are you sure you want to delete this Shipment?
        </p>
        <div class="flex flex-wrap justify-around py-4">
          <button class="border btn bg-transparent text-secondary" @click="cancelDelete">
            cancel
          </button>
          <button class="default-background btn" @click="deleteShipping">
            Delete
          </button>
        </div>
      </div>
    </div>


    <accept-modal :show-modal="showAcceptModal" @booking-subaction-completed="actionCompleted"
      @close-modal="showAcceptModal = false" :booking="selectedBooking.shipping" />
    <confirm-cancel-modal :show-modal="showCancelModal" @show-cancel-modal="
      showCancelModal = false;
    showFinCancelModal = true;
    " @booking-subaction-completed="actionCompleted" @close-modal="showCancelModal = false"
      :booking="selectedBooking.shipping" />
    <cancel-modal @booking-subaction-completed="actionCompleted" :show-modal="showFinCancelModal"
      @close-modal="showFinCancelModal = false" :booking="selectedBooking.shipping" />
    <decline-modal :show-modal="showDeclineModal" @booking-subaction-completed="actionCompleted"
      @close-modal="showDeclineModal = false" :booking="selectedBooking.shipping" />
    <process-handoff-modal :show-modal="showProcessHandoffModal" @booking-subaction-completed="actionCompleted"
      :booking="selectedBooking" @show-confirm-handoff="showConfirmHandoff"
      @close-modal="showProcessHandoffModal = false" />
    <process-return-modal :show-modal="showProcessReturnModal" @booking-subaction-completed="actionCompleted"
      :booking="selectedBooking.shipping" @close-modal="showProcessReturnModal = false"
      @hide-return="showProcessReturnModal = false" />
    <process-fulfillment-modal :show-modal="showProcessFulfillmentModal" @booking-subaction-completed="actionCompleted"
      :booking="selectedBooking" @show-confirm-fulfillment="showConfirmFulfilment = true"
      @show-request-sent="messageId = $event" @close-modal="showProcessFulfillmentModal = false" />
    <edit-booking-modal :show-modal="showEditBookingModal" :booking="selectedBooking.shipping"
      @close-modal="showEditBookingModal = false" />
    <receive-shipping-modal :show-modal="showReceiveShippingModal" :booking="selectedBooking.shipping"
      @refetchBooking="refetchBooking" @close-modal="showReceiveShippingModal = false" />
    <package-and-tag-modal :show-modal="showPackageAndTagModal" :booking="selectedBooking.shipping"
      @close-modal="showPackageAndTagModal = false" />
    <create-return-shipment-modal :show-modal="showCreateReturnShipmentModal"
      @close-modal="showCreateReturnShipmentModal = false" :booking="selectedBooking.shipping" />
    <shipping-label-modal :show-modal="showShippingLabelModal" @close-modal="showShippingLabelModal = false"
      :shippingId="selectedBooking.id" :booking="selectedBooking.shipping" />

    <update-status-modal @refetchBooking="refetchBooking" :booking="selectedBooking" :showmodal="showUpdateStatusModal"
      @close-modal="showUpdateStatusModal = false" @booking-subaction-completed="actionCompleted" />

    <upload-document-modal :showModal="showUploadDocumentModal" :shipping="selectedBooking.shipping"
      @close-modal="showUploadDocumentModal = false" />
    <receipt-acknoledged-modal :showModal="showReceiptAcknoledgedModal" :booking="selectedBooking.shipping"
      @close-modal="showReceiptAcknoledgedModal = false" />

    <confirm-handoff-modal :booking="selectedBooking.shipping" :show-modal="showconfirmhandoffmodal"
      @close-modal="showconfirmhandoffmodal = false" @show-request-sent="showRequestSentModal = true"
      :processObj="processObj" />

    <confirm-fulfillment-modal :show-modal="showConfirmFulfilment" @show-request-sent="showRequestSentModal = true"
      @close-modal="showConfirmFulfilment = false" @refetch-bookings="refetchBooking()"
      :booking="selectedBooking" :action="action" :messageId="messageId" />

    <request-sent-modal :show-modal="showRequestSentModal" @close-modal="showRequestSentModal = false" />

    <ViewDistination :center="center" :showModal="showViewDestinationModal" @open-message="openMessage"
      @close-modal="showViewDestinationModal = false" />

    <BookingTableHeaderFilter :show-modal="showFilterModal" :activeHeaders="activeHeaders"
      @close-modal="showFilterModal = false" />
    <MessageModal :show-modal="showMessageModal" @close-modal="showMessageModal = false" />

  </div>
</template>

<script>

import AcceptModal from "../Modals/AcceptModal";
import ConfirmCancelModal from "../Modals/ConfirmCancelModal";
import CancelModal from "../Modals/CancelModal";
import CreateReturnShipmentModal from "../Modals/CreateReturnShipmentModal";
import ReceiptAcknoledgedModal from "../Modals/ReceiptAcknoledgedConfirmModal";
import DeclineModal from "../Modals/DeclineReasonModal";
import ProcessHandoffModal from "../Modals/ProcessHandoffModal";
import PackageAndTagModal from "../Modals/PackageAndTagModal";
import ShippingLabelModal from "../Modals/ShippingLabelModal";
import ProcessReturnModal from "../Modals/ProcessReturnModal";
import ProcessFulfillmentModal from "../Modals/ProcessFulfillmentModal";
import EditBookingModal from "../Modals/EditBookingModal";
import ReceiveShippingModal from "../Modals/ReceiveShippingModal";
import UploadDocumentModal from "../Modals/UploadDocumentModal";
import UpdateStatusModal from "@/components/3pl/Operations/Bookings/Modals/UpdateStatusModal";
import ConfirmFulfillmentModal from "../Modals/ConfirmFulfillmentModal.vue";
import ConfirmHandoffModal from "../Modals/ConfirmHandoffModal.vue";
import RequestSentModal from "../Modals/RequestSentModal";
import ViewDistination from "@/components/Ondemand/Bookings/modals/BookingActions/ViewDistination.vue";
import BookingTableHeaderFilter from "../Modals/BookingTableHeaderFilter.vue";
import moment from "moment";
import { shippingMethods } from '@/components/constant/onboardingType.js'
import MessageModal from "@/components/Ondemand/Bookings/modals/MessageModal.vue";



export default {
  components: {

    BookingTableHeaderFilter,
    ShippingLabelModal,
    ProcessHandoffModal,
    PackageAndTagModal,
    DeclineModal,
    CreateReturnShipmentModal,
    ConfirmCancelModal,
    CancelModal,
    AcceptModal,
    ProcessFulfillmentModal,
    ProcessReturnModal,
    EditBookingModal,
    ReceiptAcknoledgedModal,
    UploadDocumentModal,
    UpdateStatusModal,
    ConfirmFulfillmentModal,
    ConfirmHandoffModal,
    RequestSentModal,
    ReceiveShippingModal,
    ViewDistination,
    MessageModal
  },
  props: {
    loading: {
      required: true,
      type: Boolean,
    },
    selectedShipments: {},
    bookings: {
      required: true,
    },
    bookingData: {},
    currentTab: {
      default: "active",
    },
    currentMethod: {
      default: "terminal-to-terminal"
    }
  },
  data() {
    return {
      showMessageModal: false,
      showFilterModal: false,
      deleteId: "",
      showDeleteModal: false,
      confirmDelete: false,
      date: "",
      selectedBookingId: null,
      selectedBooking: {},
      selectedBookings: [],
      showReceiveShippingModal: false,
      showUpdateStatusModal: false,
      showPackageAndTagModal: false,
      showDeclineModal: false,
      showProcessHandoffModal: false,
      showAcceptModal: false,
      showCancelModal: false,
      showEditBookingModal: false,
      showProcessFulfillmentModal: false,
      showProcessReturnModal: false,
      showCreateReturnShipmentModal: false,
      showItemTrack: false,
      showShippingLabelModal: false,
      shouldSelectAllBookings: false,
      showUploadDocumentModal: false,
      showReceiptAcknoledgedModal: false,
      showActions: false,
      showFinCancelModal: false,
      selectedId: "",
      showConfirmFulfilment: false,
      showconfirmhandoffmodal: false,
      showRequestSentModal: false,
      showViewDestinationModal: false,
      processObj: {},
      messageId: "",
      activeHeaders: [
        { name: "SHIPPING REF. + DATE" },
        { name: "SHIPPING SERVICE" },
        { name: "SENDER" },
        { name: "RECEIVERS" },
        { name: "SHIP FROM (ORIGIN)" },
        { name: "SHIP TO (DESTINATION)" },
        { name: "ORDER STATUS" },
      ],
      headerMap: {
        'SHIPPING REF. + DATE': '',
        'SHIPPING SERVICE': 'shippingService.orgName',
        'SENDER': '',
        'RECEIVERS': '',
        'SHIP FROM (ORIGIN)': 'sender.address.address',
        'SHIP TO (DESTINATION)': 'receiver.address.address',
        "ORDER STATUS": 'orderStatus',
        "Channel": 'shipping.shippingservice.shippingMethod',
        "Top distance": 'shipping.shippingservice.distance',
        "Load weight": 'grossWeight',
        "Income": ''
      },
    };
  },
  watch: {
    isTableFilter() {
      let container = document.getElementById("table-wrapper");
      container.scrollLeft += 500;
    },
    shouldSelectAllBookings(val) {
      if (val) {
        this.bookings.forEach((booking) => {
          this.selectedBookings.push(booking.id);
        });
      } else {
        this.selectedBookings = [];
      }

      this.$emit('newSelect', this.selectedBookings)
    },
    selectedShipments() {
      this.selectedBookings = this.selectedShipments;
      this.selectedShipments.length === 0 && (this.shouldSelectAllBookings = false);
    },
    sortTable() {
      this.bookings = this.toSort(
        this.bookings,
        "shippingReference",
        this.sortTable
      );
    },
  },
  // 
  computed: {
    consolidationId() {
      return this.$store.getters.getShipConsolidationID;
    },
    userid() {
      return this.$store.state.authentication.quantumUserId;
    },
    allTableContent() {
      return this.bookings;
    },
  },
  methods: {
    statusColors(status) {
      const opac = "25";
      switch (status) {
        case "pending":
          return { color: "#FFA600", backgroundColor: "#FCC21040" };
        case "received_at_origin_terminal":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "dispatched_from_origin_terminal":
          return { color: "#10233E", backgroundColor: "#10233E" + opac };
        case "consolidated":
          return { color: "#FFA600", backgroundColor: "#FCC21040" };
        case "in_transit_to_destination_terminal":
          return { color: "#FFA600", backgroundColor: "#FCC21040" };
        case "arrived_at_destination_terminal":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "unloading":
          return { color: "#10233E", backgroundColor: "#10233E" + opac };
        case "destination_sorting":
          return { color: "#FFA600", backgroundColor: "#FCC21040" };
        case "dispatched_for_delivery":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "delivered":
          return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
        case "canceled":
          return { color: "#D72638", backgroundColor: "#D72638" + opac };
        case "handed_off":
          return { color: "#FFA600", backgroundColor: "#FCC21040" };
        case "dispatched":
          return { color: "#FFA600", backgroundColor: "#FCC21040" };
      }
    },
    openMessage() {
      this.showViewDestinationModal = false;
      this.showMessageModal = true
    },
    receieverContactName(booking) {
      return booking?.receiver?.contactName || 'N/A'
    },
    recieverAddress(booking) {
      let type = booking?.shipping?.shippingMethod;
      switch (type) {
        case shippingMethods.D2D:
          return (booking?.shipping?.shipmentReceiever || []).map((item) => item?.location?.address?.name || "N/A").join(",")

        case shippingMethods.T2T:
          return booking?.receiver?.address?.address || booking?.receiver?.address?.name || "N/A"

        default:
          return booking?.receiver?.address?.address || booking?.receiver?.address?.name || "N/A"
      }
    },
    addoneHourToTime(IOStime) {
      // Parse the date string
      let date = moment(IOStime);

      // Add one hour
      date.add(0, 'hour');

      // Format the date to hh:mm:ss
      return date.format('HH:mm:ss');
    },
    getNestedValue(obj, path) {
      const value = path.split('.').reduce((acc, part) => acc && acc[part], obj);
      return value === null || value === undefined || value === '' ? 'N/A' : value;
    },

    refetchBooking() {
      this.$emit("refetchBookings");
    },
    viewDeleteModal(shippingId) {
      this.showDeleteModal = true;
      this.deleteId = shippingId;
    },
    viewDestination(val) {

      this.center = [
        {
          lat: val?.shipping?.shipperlocation?.address?.lat || 0,
          lng: val?.shipping?.shipperlocation?.address?.lng || 0,
        },
        {
          lat: val?.shipping?.consigneelocation?.address?.lat || 0,
          lng: val?.shipping?.consigneelocation?.address?.lng || 0,
        }
      ];
      this.$store.dispatch("saveNewCurrentShipping", val?.shipping);
      this.showViewDestinationModal = true;
    },
    async deleteShipping() {
      const shippingId = this.deleteId;
      try {
        const response = await this.$_deleteShipping(shippingId);
        this.log(response);
        this.generateToast("Shipping deleted", "success");
        this.$emit("booking-action-completed");
        this.$emit("refetchBookings");
      } catch (error) {
        this.handleError(error);
      }
      this.showDeleteModal = false;
    },
    cancelDelete() {
      this.showDeleteModal = false;
    },
    returnItemsWeights(packageItems) {
      const packageWeights = [];
      packageItems.forEach((item) => {
        if (item.estimatedWeight) {
          packageWeights.push(item.estimatedWeight);
        }
      });
      const weight = packageWeights.join(", ");
      return weight ? weight : "N.A";
    },
    scrollLeft() {
      let container = document.getElementById("table-wrapper");
      container.scrollLeft += 10000;
    },
    actionCompleted() {
      this.scrollLeft();
      this.$emit("booking-action-completed");
    },
    updateStatus(shipment) {
      localStorage.setItem("currentShippment", JSON.stringify(shipment));
      this.selectedBooking = shipment;
      this.showUpdateStatusModal = true;
    },
    setBookingOpenModal(shipment) {
      localStorage.setItem("currentShippment", JSON.stringify(shipment));
      this.selectedBooking = shipment;
      this.showShippingLabelModal = true;
    },
    toggleActions(id) {
      if (this.selectedBookingId) {
        this.selectedBookingId = null;
      } else {
        this.selectedBookingId = id;
      }
    },
    showConfirmHandoff(processObj) {
      this.processObj = processObj;
      this.showconfirmhandoffmodal = true;
    },
    action(bookingId, booking) {
      localStorage.setItem("currentShippment", JSON.stringify(booking));

      this.preLoadDetails(booking);
      this.getTerminals();
      this.$router.push({
        name: "BookingEdit",
        params: { bookingId: bookingId },
      });
    },
    preLoadDetails(booking) {
      this.$store.dispatch("saveBookingInformation", {
        property: "shipper",
        value: booking.shipping.shipperlocation,
      });

      this.$store.dispatch("saveBookingInformation", {
        property: "consignee",
        value: booking.shipping.consigneelocation,
      });

      this.$store.dispatch("savePackages", booking.shipping.packagees);

      this.$store.dispatch("saveShippingId", booking.id);

      this.$store.dispatch("saveBookingInformation", {
        property: "shippingInformation",
        value: booking,
      });

      this.$store.dispatch("saveBookingInformation", {
        property: "packageType",
        value: booking.shipping.packageType,
      });
    },
    async getTerminals() {
      const payload = {
        orgId: this.$store.state.authentication.organizationId,
        takeOffLocation: this.booking.shipping.shipperlocation.state,
        arrivalLocation: this.booking.shipping.consigneelocation.state,
      };
      try {
        const response = await this.$_getTerminals(payload);

        this.$store.dispatch(
          "saveTakeOffTerminals",
          response.data.data.takeOffLocation
        );
        this.$store.dispatch(
          "savePickUpTerminals",
          response.data.data.arrivalLocation
        );

        this.$router.push({
          name: "BookingSummary",
          params: { id: this.booking.shipingId },
        });
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mirror{
  transform: rotateX(180deg);
}
.order_status {
  @apply text-xs w-[120px] whitespace-nowrap capitalize text-ellipsis overflow-hidden rounded-2xl py-1.5 px-3
}

.deleteModal {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  transform: scale(1.1);
  transition: visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s;
}

.card {
  left: 40%;
  top: 40%;
}

.width-xs {
  min-width: 3rem !important;
}

#table-wrapper {
  margin: 2rem 0 0;
  overflow-x: auto;
}

.table-wrapper,
.table-wrapper .custom-table {
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
}

/* width */
.table-wrapper::-webkit-scrollbar {
  cursor: pointer;
  width: 5px;
  height: 8px;
}

/* Track */
.table-wrapper::-webkit-scrollbar-track {
  background: #c4c4c4;
}

/* Handle */
.table-wrapper::-webkit-scrollbar-thumb {
  background: #fab427;
  width: 5px;
  border-radius: 20px;
}

.table-header {}

.custom-table {
  margin-top: 0;
}

th {
  min-width: 10rem;
  color: #19304d;
  opacity: 0.7;
  padding: 0.25rem;
  font-weight: normal;
}

.checkbox {
  display: initial;
  width: 1rem;
  height: 1rem;
}

td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 0.75rem 0.25rem;
  vertical-align: top;

  span {
    display: block;
  }

  // span:last-of-type {
  //   font-weight: normal;
  //   color: #10233e;
  //   opacity: 0.6;
  //   padding-top: 0.25rem;
  //   font-size: 0.8rem;
  // }
}

.booking-channel-col {
  width: 15%;
}

.shipping-ref-col {
  width: 13%;
}

.booking-status {
  background: #fae5e7;
  color: #d72638 !important;
  border-radius: 10px;
  padding: 0.5rem;
  font-weight: 500 !important;
  opacity: 1 !important;
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}

.table-date {
  width: 12%;
}

.actions {
  position: absolute;
  background: #ffffff;
  top: 0;
  right: 2rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 15rem;
  background: #ffffff;
  /* Stroke */
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }

  >div {
    display: flex;
    align-items: center;
    padding: 0.75rem;

    &:hover {
      background: rgb(225, 225, 225);
    }
  }

  .disabled {
    opacity: 0.5;

    &:hover {
      background: none;
    }
  }
}

.router {
  text-decoration: none !important;
  color: #84868b;
}

.router:hover {
  color: #fcc210;
}

.default-background {
  background-color: #fab427;
}
</style>
